import * as auth from "./auth/auth.service";
import * as tournament from "./tournament/tournament.service";
import * as player from "./player/player.service";
import * as shop from "./shop/shop.service";
import * as articles from "./articles/articles.service";
import * as user from "./user/user.service";
import * as dashboard from "./dashboard/dashboard.service";
import * as instagram from "./instagram/instagram.service";
import * as youtube from "./youtube/youtube.service";
import * as judge from "./judge/judge.service";
import * as cards from "./cards/cards.service";
import * as points from "./points/points.service";
import * as assets from "./assets/assets.service";
import * as contacts from "./contacts/contacts.service";
import * as presets from "./presets/presets.service";
import * as leaderboard from "./leaderboard/leaderboard.service";
import * as rules from "./rules/rules.service";
import * as communityLeader from "./community-leader/communityLeader.service";

export default {
	auth,
	player,
	shop,
	tournament,
	user,
	dashboard,
	articles,
	instagram,
	youtube,
	judge,
	cards,
	points,
	assets,
	contacts,
	presets,
	leaderboard,
	rules,
	communityLeader,
};
